export const SeasonsEndpoints = {
	season: '/seasons/{year}/{season}',
	seasonNow: '/seasons/now',
	seasonsList: '/seasons',
	seasonUpcoming: '/seasons/upcoming'
} as const
